import { PostMethod } from '../../serviceHelper';

const getMethods = (service: 'FlowManager', controller: 'ProjectManager') => ({
	GetProcessesLean: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetProcessesLean'
	}),
	GetProcessSteps: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetProcessSteps'
	}),
	GetProcessStepsWithStatistics: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetProcessStepsWithStatistics'
	}),
	GetFlowFileContent: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetFlowFileContent'
	}),
	GetWorkflowDataByProcessId: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetWorkflowDataByProcessId'
	}),
	DeleteProcess: new PostMethod<any, any>({
		service,
		controller,
		method: 'DeleteProcess'
	}),
	UpdateWorkflowData: new PostMethod<any, any>({
		service,
		controller,
		method: 'UpdateWorkflowData'
	}),
	UpgradePackageVersion: new PostMethod<any, any>({
		service,
		controller,
		method: 'UpgradePackageVersion'
	})
});

export { getMethods };
